import type { OperatorLocale } from "@/locales/fr/operator";

const operatorLocale: OperatorLocale = {
  operator: {
    openedFolders: "Opened folders",
    openedFoldersN: "Opened folders ({n})",
  },
};

export default operatorLocale;
